// Helpers compartidos por la lista y la edición de Monedas.
// El catálogo es dueño en código (lo proyecta el composer): acá el back office
// solo lee, salvo `apr` y `enabled`.

// APR efectivo que cobra el robot. fase46 — APR ÚNICO: el campo `apr` que se
// carga acá ES el APR. Deshabilitada → 0. Vacío/ausente → 0 (no devenga; ya no
// se cae a ningún valor del código). `aprOverride`/`defaultApr` se siguen
// leyendo por compatibilidad con docs que todavía no migró la proyección.
// ESPEJO de effectiveApr() en el composer y en portfolio.ts de web/app.
export function effectiveApr(record: any): number | null {
  if (!record) return null;
  if (record.enabled === false) return 0;
  const raw =
    record.apr ??
    record.aprOverride ?? // legacy
    record.defaultApr; // legacy
  if (raw === null || raw === undefined || raw === '') return 0;
  const n = Number(raw);
  return Number.isFinite(n) && n > 0 ? n : 0;
}

// Una moneda sin el flag se considera habilitada (ausente = habilitada).
export function isEnabled(record: any): boolean {
  return record?.enabled !== false;
}

// ¿La moneda la administra el catálogo del código (composer la proyecta con
// managedByCatalog:true)? Si NO, es una moneda legacy/huérfana de Firestore que
// el composer ya no asegura: el back office la puede eliminar (no se recrea).
export function isManagedByCatalog(record: any): boolean {
  return record?.managedByCatalog === true;
}

// Etiqueta legible de la fuente de precio REAL. Cripto y oro cotizan por
// CoinMarketCap (el oro vía XAUT); las divisas por Frankfurter (BCE) con la
// base = ticker (EUR/USD, CHF/USD); los ETFs (SPY/QQQ) por la fuente bursátil
// (Tiingo, cierre del ETF). `coingecko`/`metal` quedan como compat para docs viejos.
// fase68c — decía «Stooq», que es justamente la fuente que NO se puede usar:
// Stooq y Yahoo bloquean las IPs de DigitalOcean y por eso se pasó a Tiingo. Una
// etiqueta que nombra mal la fuente manda a diagnosticar contra el proveedor
// equivocado, que es el mismo modo de falla que costó las dos vueltas del forex.
export function priceSourceLabel(record: any): string {
  switch (record?.priceSource) {
    case 'peg':
      return 'Paridad USD (1:1)';
    case 'cmc':
      return 'CoinMarketCap';
    case 'forex':
      return `Forex ${String(record?.name ?? '').toUpperCase() || '—'}/USD (BCE)`;
    case 'equity':
      return 'Bursátil (Tiingo)';
    case 'coingecko':
      return 'CoinGecko (legacy)';
    case 'metal':
      return 'Metal';
    default:
      // Compat con docs viejos sin priceSource.
      if (record?.pegUsd) return 'Paridad USD (1:1)';
      if (Number(record?.cmcId) > 0) return 'CoinMarketCap';
      return '—';
  }
}

export function formatApr(value: number | null): string {
  return value === null ? '—' : `${value}%`;
}
